// CANONICAL COPY (GH #7115). src/constants/obligations/obl-security-monitoring.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-security-monitoring',
  title: 'Review security monitoring of networks, systems and third parties',
  description:
    'Confirm that networks, systems, applications, user and third-party service-provider activity are continuously or periodically monitored for anomalous behaviour. Review the monitoring coverage, detection rules, alerting thresholds and recent incidents triggered by the monitoring programme. Auto-satisfied when the Microsoft Defender security feed has been synced within 30 days — an active Defender sync is direct evidence that centralised security event alerting and host-based detection (CIS 13.1, 13.2) are running. Falls back to a published and current monitoring procedure when Defender is not connected.',
  category: 'technical',
  scfIds: ['SCF-OPS-007'],
  cadence: { frequency: '6m', anchor: 'domain' },
  strategy: 'any',
  fulfilmentCriteria: [
    // Tier 1: Active Defender sync proves centralised security alerting is running
    // (CIS 8.11 — audit log reviews; CIS 13.1 — centralise security event alerting;
    // CIS 13.2 — host-based intrusion detection). Tighter 30-day window for monitoring.
    {
      type: 'defender-feed-fresh',
      maxAgeDays: 30,
      description:
        'Microsoft Defender security feed has been synced within the last 30 days — confirms centralised security event collection and host-based detection are active',
    },
    // Tier 2: Manual path for tenants not using Defender.
    { type: 'document-published', description: 'Security monitoring procedure is published' },
    { type: 'document-within-sla', description: 'Procedure review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
